import { render, staticRenderFns } from "./AgentFloatingIcon.vue?vue&type=template&id=4b54d613&scoped=true"
import script from "./AgentFloatingIcon.vue?vue&type=script&lang=js"
export * from "./AgentFloatingIcon.vue?vue&type=script&lang=js"
import style0 from "./AgentFloatingIcon.vue?vue&type=style&index=0&id=4b54d613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54d613",
  null
  
)

export default component.exports